import { listCard } from "./fields.css";

import { useAtomValue } from "jotai";

import { Fieldset, FieldsetLegend } from "@frontend/components/atoms/Fieldset";
import { Icon } from "@frontend/components/atoms/Icon";
import { Input } from "@frontend/components/atoms/Input";
import { useArrayField, useField } from "@frontend/hooks/form";
import { Trans } from "@lingui/react/macro";

import { useContactForm } from "../../hooks/useContactForm";
import { ContactEmailPlaceLabels } from "../../i18n";
import { isEditModeAtom } from "../../stores";
import type { ContactEmail, EmailListItemAddressField } from "../../types";
import { AddButton } from "./AddButton";
import { ClipboardButton } from "./ClipboardButton";
import { FieldList } from "./FieldList";
import { Place } from "./Place";

export function EmailList() {
  const { contactForm } = useContactForm();

  const field = contactForm.fields.emails;

  const rows = useArrayField(field);

  const editMode = useAtomValue(isEditModeAtom);

  const removeHandler = (index: number) => {
    rows.remove(rows.itemAtoms[index]!);
  };

  const insertHandler = () => {
    rows.append({ place: "", address: "" } as ContactEmail);
  };

  return (
    <Fieldset variant="list" orientation="horizontal" className={listCard}>
      <FieldsetLegend
        count={rows.items.length}
        action={editMode && <AddButton onClick={insertHandler} />}
      >
        <Trans>Emails</Trans>
      </FieldsetLegend>
      <FieldList
        field={field}
        onRemove={removeHandler}
        renderLeft={(item) => (
          <Place field={item.fields.place} labels={ContactEmailPlaceLabels} />
        )}
        renderRight={(item) => (
          <EmailListItemAddress field={item.fields.address} />
        )}
      />
    </Fieldset>
  );
}

function EmailListItemAddress({ field }: { field: EmailListItemAddressField }) {
  const editMode = useAtomValue(isEditModeAtom);

  const { value, setValue, error } = useField(field);

  return editMode ? (
    <Input
      value={value}
      onValueChange={setValue}
      invalid={null !== error}
      size="sm"
    />
  ) : (
    <>
      <span>{value === "" ? "N/A" : value}</span>
      <ClipboardButton value={value ?? ""} />
    </>
  );
}
